module.exports = __webpack_public_path__ + "static/img/title.fc3628b6.png";